import React, { createContext, useContext } from 'react';

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        return { role: payload.role };
      } catch (e) {
        console.warn('Failed to parse JWT token:', e.message);
        return { role: 'user' };
      }
    }
    return { role: 'user' };
  }
  return context;
};

export { AuthContext };